module.exports = __webpack_public_path__ + "assets/11.jpg?b779eca12905edb571bcf6ddaad660b5";